__turbopack_context__.v({
  "scoreBarTable": "YOKlbG_scoreBarTable",
});
